import { createContext } from "react";

import { IShoppingCartContext } from "../type/IShoppingCartContext";
import { IProductContext } from "../type/IPriceContext";

export const ShoppingCartContext = createContext<IShoppingCartContext>({} as IShoppingCartContext);
export const ProductContext = createContext<IProductContext>({} as IProductContext);